import PeriodType from "@/models/Shared/PeriodType";

export default (periodType: PeriodType) => {
    let returnVal = "Undefined";
    switch (periodType) {
        case PeriodType.Day:
            returnVal = "Day(s)"
            break;
        case PeriodType.Week:
            returnVal = "Week(s)"
            break;
        case PeriodType.Month:
            returnVal = "Month(s)"
            break;
        case PeriodType.Quarter:
            returnVal = "Quarter(s)"
            break;
        case PeriodType.Year:
            returnVal = "Year(s)"
            break;
    }
    return returnVal;
}